export const LOADING_USER = "LOADING_USER";
export const GET_USER_LIST = "GET_USER_LIST";
export const ADD_USER = "ADD_USER";
export const GET_ROLE = "GET_ROLE";
export const GET_USER_ID = "GET_USER_ID";
export const ADD_USER_ROLE = "ADD_USER_ROLE";
export const GET_USER_LIST_BY_ROLE = "GET_USER_LIST_BY_ROLE";
